export default __webpack_public_path__ + "static/code-72353f2440c6165358566478108898e5.png";